var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlPageDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2857 13.7143H8.71429C8.3198 13.7143 8 14.0341 8 14.4286V15.8571C8 16.2516 8.3198 16.5714 8.71429 16.5714H27.2857C27.6802 16.5714 28 16.2516 28 15.8571V14.4286C28 14.0341 27.6802 13.7143 27.2857 13.7143ZM27.2857 25.1429H8.71429C8.3198 25.1429 8 25.4627 8 25.8571V27.2857C8 27.6802 8.3198 28 8.71429 28H27.2857C27.6802 28 28 27.6802 28 27.2857V25.8571C28 25.4627 27.6802 25.1429 27.2857 25.1429ZM12.8259 10.8571H23.1746C23.3178 10.8571 23.4551 10.8002 23.5564 10.6989C23.6576 10.5976 23.7144 10.4602 23.7143 10.317V8.53973C23.7143 8.39659 23.6574 8.2593 23.5562 8.15808C23.455 8.05686 23.3177 8 23.1746 8H12.8259C12.6827 7.99988 12.5453 8.05669 12.444 8.15793C12.3426 8.25916 12.2857 8.39651 12.2857 8.53973V10.317C12.2857 10.6153 12.5276 10.8571 12.8259 10.8571ZM23.1746 22.2857C23.3178 22.2857 23.4551 22.2288 23.5564 22.1275C23.6576 22.0262 23.7144 21.8888 23.7143 21.7455V19.9683C23.7143 19.6702 23.4726 19.4286 23.1746 19.4286H12.8259C12.6827 19.4285 12.5453 19.4853 12.444 19.5865C12.3426 19.6877 12.2857 19.8251 12.2857 19.9683V21.7455C12.2857 21.8888 12.3426 22.0262 12.4439 22.1275C12.5452 22.2288 12.6826 22.2857 12.8259 22.2857H23.1746Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlPageDefaultIcon);
export default __webpack_public_path__ + "static/media/html-page-default-icon.bf34367cd7196840bb3aed09ffad536d.svg";
export { ForwardRef as ReactComponent };